import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    inputId: String,
  };

  clear() {
    const inputId = this.inputIdValue;
    const input = document.getElementById(inputId);
    input.value = "";
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.dispatchEvent(
      new CustomEvent("icon-library:cleared", {
        bubbles: true,
        detail: {},
      })
    );
    document.getElementById(`${inputId}-link`).innerHTML = "";
    document.getElementById(`${inputId}-clear`).classList.add("hidden");
  }
}
